
import styled, { css } from 'styled-components'
import {
  Button,
  Div,
  H4,
  ButtonForm,
} from 'konsys-ui'
import { theme, media, minMedia } from '../../../styles/_variables'


export const ActionZone = styled.div`
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 60px 0px 60px 0px;
    ${media.tablet`
      justify-content: center;
      width: 100%;
      height: 160px;
      margin: 0px 0px 60px 0px;
    `}
`

export const ActionZone2 = styled.div`
    width: 70%;
    height: 160px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0px 40px 0px;
    @media only screen and (max-width: 960px) {
      width: 100%;
    }
    @media only screen and (max-width: 768px) {
      justify-content: space-between;
      width: 100%;
    }
`

export const ButtonCalculator = styled(Button)`
  width: 300px;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: ${theme.fonts.size.title};
  border-radius: 25px;
  padding: 2px 8px !important;
  background-color: ${theme.color.greenPrimary};
  box-shadow: 2px 2px 0px 1px rgb(110, 201, 190, 0.4) !important;
  & > p {
    margin: 0px !important;
    font-size: ${theme.fonts.size.title};
  }
`

export const IconCalculate = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 8px;
`

export const WidthContainer = styled.div`
  width: 100%;
  max-width: ${theme.maxWidth};
  margin-left: 50%;
  transform: translateX(-50%);
  padding: 0 16px;
  padding: ${props => (props.padding ? props.padding : '0 16px')};
  margin-top: ${props => (props.top ? '0px' : '-60px')};
  margin-bottom: ${props => (props.isOne ? '0px' : '-60px')};
  ${props => props.bgColor && css`
    background-color: ${props.bgColor};
  `}
  @media only screen and (min-width: 961px) and (max-width: 1024px) {
    max-width: 100vw;
    padding: 0 16px;
  }
  ${minMedia.laptopXL`
    max-width: 59vw;
  `}
  @media only screen and (min-width: 1025px) {
    padding: 0 0px;
  }
  ${media.tablet`
    width: 100%;
    max-width: 100%;
  `}
`

export const Container = styled.div`
  width: 100%;
  max-width: 80vw;
  margin-left: 50%;
  transform: translateX(-50%);
  padding: 0 16px;
  padding: ${props => (props.padding ? props.padding : '0 16px')};
  ${props => props.bgColor && css`
    background-color: ${props.bgColor};
  `}
  ${minMedia.laptopXL`
    max-width: 59vw;
  `}
  ${media.tablet`
    width: 100%;
    max-width: 100%;
  `}
`

export const Content = styled.div`
    width: 100%;
    background-color: #f6f5f5;
    @media only screen and (min-height: 1980px) {
      border-top: 59.9px solid ${theme.color.greenPrimary};
      border-bottom: ${props => (props.step === 2 || props.data === 1 ? '0px' : `59.9px solid ${theme.color.greenPrimary}`)};
    }
    border-top: 60px solid ${theme.color.greenPrimary};
    border-bottom: ${props => (props.step === 2 || props.data === 1 ? '0px' : `60px solid ${theme.color.greenPrimary}`)};
`

export const FooterContent = styled.div`
    width: 100%;
    background-color: #f6f5f5;
    padding-top: 1px;
    padding-bottom: 1px;
`

export const SummaryDiv = styled.div`
  width: 20%;
  // margin-left: 12px;
  position: relative;
`

export const SummaryDivMobile = styled.div`
  width: 100%;
  padding: 0px 16px 0px 16px;
  position: relative;
  margin-top: 24px;
`

export const ContentPart = styled.div`
  width: 100%;
`

export const Bar = styled(Div)`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled(H4)`
  color: ${theme.color.offWhite};
  ${media.mobileXL`
    margin-left: -60px;
    font-size: ${theme.fonts.size.extraNormal};
  `}
  ${media.mobileM`
    margin-left: -60px;
    font-size: ${theme.fonts.size.normal};
  `}
`

export const ButtonBack = styled(Button)`
  padding: 8px 0px;
  background-color: ${theme.color.greenPrimary};
  border-color: ${theme.color.greenPrimary};
  ${media.mobileXL`
    margin-left: 0px;
  `}
  > p {
    ${media.mobileM`
      font-size: ${theme.fonts.size.label};
    `}
  }
`

export const ButtonFormAction = styled(ButtonForm)`
  margin: 0px;
  padding: 8px 24px;
  white-space: nowrap;
  align-items: center;
  display: flex;
  & > span {
    font-size: ${theme.fonts.size.subTitle} !important;
    line-height: ${theme.fonts.size.subTitle} !important;
    ${media.mobileXL`
      font-size: ${theme.fonts.size.small} !important;
      margin: 0px 8px 0px 8px !important;
    `}
  }
  & > i {
    font-size: ${theme.fonts.size.subTitle} !important;
    width: 30px !important;
    height: 30px !important;
    ${media.mobileXL`
      width: 18px !important;
      height: 18px !important;
      font-size: 18px !important;
      margin: 0 !important;
    `}
  }
  ${media.mobileXL`
    margin-left: 0px !important;
    padding: 8px 12px;
  `}
  
`

export const SummaryPanel = styled.div`
  width: 100%;
  box-shadow: 0 16px 32px 0px rgba(51, 3, 0, 0.7);
  position: fixed;
  z-index: ${props => (props.active ? '9999' : '9')};
  bottom: 0;
  max-height: ${props => (props.active ? '100vh' : '40px')};
  height: ${props => (props.active ? '100%' : '40px')};
  background: #FFF;
  transition: ${props => (props.active ? 'all 0.3s ease-in' : 'all 0.3s ease-out')};
  touch-action: none;
  -ms-touch-action: none;
`

export const SummaryToggle = styled.div`
  padding: 0px 19px;
  background-color: ${theme.color.greenPrimary};
  height: 40px;
  & > h4 {
    color: ${theme.color.offWhite};
    font-size: ${theme.fonts.size.extraNormal};
    font-weight: bold;
    margin: 0px;
  }
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export default ActionZone



// WEBPACK FOOTER //
// ./src/pages/package-page/detail/styled.js